import Helper from "../../Helper";
import { MapObject } from "../../models/MapObject";
import { plotFetch } from "../Helper/ApiRequest";

export function getProjectMapObjects(
    team_subdomain: string,
    project_token: string,
    timezone: string
): Promise<MapObject[]> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/map_objects`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((mapObject: any) => MapObject.fromApiObject(mapObject, timezone));
        })
        .catch((_) => {
            return [];
        });
}

export function getProjectMapObject(
    team_subdomain: string,
    project_token: string,
    map_object_id: number,
    timezone: string
): Promise<MapObject | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/map_objects/${map_object_id}`;

    return plotFetch(url, { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return MapObject.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

export function updateMapObject(
    team_subdomain: string,
    projectToken: string,
    mapObject: MapObject,
    timezone: string
): Promise<MapObject | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${projectToken}/map_objects/${mapObject.id}`;

    return plotFetch(url, {
        method: "PUT",
        body: JSON.stringify({ map_object: mapObject.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return MapObject.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}
